module.exports = __webpack_public_path__ + "static/img/shopEnter.a8f8f25.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shopEnter.png
// module id = 3135
// module chunks = 1